import * as React from 'react'
import { components, OptionProps } from 'react-select'

import { Flex, Heading } from 'components/primitives'
import { SelectOption } from 'types/global'
import { dustyGray, mercury } from 'theme/colors'
import { pxToRem } from 'theme/utils'
import { getIconByCategory } from 'icons'

const iconProps = {
  size: pxToRem(24),
  color: dustyGray,
}

type CustomSelectOption = SelectOption & { locationType: string } & any

export const Option: React.FC<OptionProps<CustomSelectOption, boolean, any>> = ({
  data: { value, label, locationType },
  ...rest
}) => {
  let category = ['AIRPORT', 'CITY', 'BRANCH'].includes(locationType) ? locationType.toLowerCase() : 'city'
  const Icon = getIconByCategory(category)

  return (
    <components.Option data={{ value, label, locationType }} {...rest}>
      <Flex
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
          margin: `0 ${pxToRem(16)}`,
        }}
      >
        <Flex style={{ justifyContent: 'center', alignItems: 'center', marginRight: pxToRem(16) }}>
          <Icon {...iconProps} />
        </Flex>
        <Flex
          style={{
            padding: `${pxToRem(16)} 0`,
            borderBottom: `1px solid ${mercury}`,
            flexDirection: 'column',
            height: '100%',
            flex: 2,
          }}
        >
          <Heading as="h5" style={{ fontSize: pxToRem(14) }}>
            {label}
          </Heading>
          <Heading as="h6" style={{ fontSize: pxToRem(12) }}>
            {locationType}
          </Heading>
        </Flex>
      </Flex>
    </components.Option>
  )
}

export default Option
